export default "__VITE_ASSET__DRDr0nvY__"